const H2Icon = () => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M15.1042 5.9895V3.4895C15.1042 3.40356 15.0339 3.33325 14.948 3.33325H4.323C4.23706 3.33325 4.16675 3.40356 4.16675 3.4895V5.9895C4.16675 6.07544 4.23706 6.14575 4.323 6.14575H5.41675C5.50269 6.14575 5.573 6.07544 5.573 5.9895V4.7395H8.85425V15.677H7.05737C6.97144 15.677 6.90112 15.7473 6.90112 15.8333V16.927C6.90112 17.0129 6.97144 17.0833 7.05737 17.0833H12.2136C12.2996 17.0833 12.3699 17.0129 12.3699 16.927V15.8333C12.3699 15.7473 12.2996 15.677 12.2136 15.677H10.4167V4.7395H13.698V5.9895C13.698 6.07544 13.7683 6.14575 13.8542 6.14575H14.948C15.0339 6.14575 15.1042 6.07544 15.1042 5.9895Z'
      fill='#818181'
    />
  </svg>
);

export default H2Icon;
